import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import {useTranslation} from "react-i18next";
import {AlertButton} from "./AlertButton";

export function DeleteButton(props: {
  onClick: () => void
}) {
  const {t} = useTranslation();
  return (
    <AlertButton onClick={props.onClick} title={t('buttons.delete')}>
      <DeleteIcon style={{paddingRight: "8px"}}/>
    </AlertButton>
  )
}
